module.exports = __webpack_public_path__ + "static/img/img_yewu2.21a5f3d.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/web_img/img_yewu2.png
// module id = 8qxw
// module chunks = 1